const getWithDot = <T>(fullKey: string, obj: Record<string, any>): T | undefined => {
  return fullKey.split('.').reduce((acc: any, key) => {
    if (typeof acc === 'undefined') {
      return undefined;
    }

    return acc[key];
  }, obj) as T | undefined;
};

export default getWithDot;
